interface InvalidIdNoticeProps {
  label: string;
}

export const InvalidIdNotice = ({ label }: InvalidIdNoticeProps) => (
  <p className="text-sm text-accent-red">{label} inválido.</p>
);